// AUTO-GENERATED by xm-icons plugin — do not edit manually

export type XmIconName =
  | 'add-photo-alternate-outlined'
  | 'copy-filled'
  | 'copy-outlined'
  | 'filter-list-outlined'
  | 'label-outlined'
  | 'list-alt-outlined'
  | 'notification-important-outlined'
  | 'option-filled'
  | 'option-outlined'
  | 'text-select-jump-to-end-outlined'
  | 'widget-compress-outlined'
  | 'widget-expand-outlined';

export const xmIconNames: XmIconName[] = [
  'add-photo-alternate-outlined',
  'copy-filled',
  'copy-outlined',
  'filter-list-outlined',
  'label-outlined',
  'list-alt-outlined',
  'notification-important-outlined',
  'option-filled',
  'option-outlined',
  'text-select-jump-to-end-outlined',
  'widget-compress-outlined',
  'widget-expand-outlined',
];
